module.exports = __webpack_public_path__ + "img/rank_more06.d0f10085.png";